let obj = {
    locales: {},
    spam_section:""
}
export default obj;